import { createPortal } from 'react-dom';
import { ToastQueue, useToastQueue } from 'react-stately';
import { ClarionToastRegion } from './ToastRegion';
import { ToastProps } from './toast-types';

const globalToastQueue = new ToastQueue<ToastProps>({ maxVisibleToasts: 5 });

export const ClarionToaster = {
  show: (options: ToastProps) =>
    globalToastQueue.add(options, {
      timeout: options?.timeout ?? 5000,
    }),

  success: (options: ToastProps) => ClarionToaster.show({ ...options, intent: 'success' }),

  danger: (options: ToastProps) => ClarionToaster.show({ ...options, intent: 'danger' }),

  warning: (options: ToastProps) => ClarionToaster.show({ ...options, intent: 'warning' }),

  info: (options: ToastProps) => ClarionToaster.show({ ...options, intent: 'primary' }),

  dismiss: (key: string) => globalToastQueue.close(key),

  clear: () => globalToastQueue.clear(),
};

/**
 * Provider component that renders the toast region.
 * This should be rendered once at the root of your application.
 */
export function ClarionToasterProvider() {
  const state = useToastQueue(globalToastQueue);

  if (state.visibleToasts.length === 0) {
    return null;
  }

  return createPortal(<ClarionToastRegion queue={globalToastQueue} />, document.body);
}
